/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Card, Typography, CircularProgress } from "@mui/material";
import "../../styles/studentcomponentsstyles/StudentDashboard.css";
import PrimaryButton from "../../components/buttons/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setStudent } from "../../redux/studentReducer/studentSlice";

const StudentDashboard = () => {
  const url = process.env.REACT_APP_BACKEND_URL;
  const currentUser = useSelector((state) => state.user.currentUser);
  const [studentState, setStudentState] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fetchStudent = () => {
    fetch(`${url}/api/student/getstudent/${currentUser.id}`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          alert(response.status);
        }
      })
      .then((data) => {
        dispatch(setStudent(data));
        setStudentState(data);
      })
      .catch((error) => alert(error.message));
  };
  useEffect(() => {
    fetchStudent();
  }, []);
  return !studentState ? (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      width="100%"
    >
      <CircularProgress color="success" />
    </Box>
  ) : (
    <Box sx={{ pt: 10 }}>
      <Typography variant="h4" sx={{ color: "#08422D", p: 3, fontWeight: 600 }}>
        Student Dashboard
      </Typography>
      <Card
        sx={{
          px: 3,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
        elevation={0}
      >
        {!studentState?.group?.status && (
          <PrimaryButton
            onClick={() => {
              navigate("/group-formation");
            }}
            sx={{ width: "33%", height: "150px", my: 1 }}
          >
            Create Project Group
          </PrimaryButton>
        )}
        <PrimaryButton
          onClick={() => {
            navigate("/idea-submission");
          }}
          sx={{ width: "33%", height: "150px", my: 1 }}
        >
          Submit Project Idea
        </PrimaryButton>
        {studentState?.group?.status && (
          <PrimaryButton
            onClick={() => {
              navigate("/fr-submission");
            }}
            sx={{ width: "33%", height: "150px", my: 1 }}
          >
            Functional Requirements
          </PrimaryButton>
        )}
        <PrimaryButton
          onClick={() => {
            navigate("/documentation-submission");
          }}
          sx={{ width: "33%", height: "150px", my: 1 }}
        >
          Submit Documentation
        </PrimaryButton>
        <PrimaryButton
          onClick={() => {
            navigate("/add-weekly-progress");
          }}
          sx={{ width: "33%", height: "150px", my: 1 }}
        >
          Submit Weekly Progress Report
        </PrimaryButton>
        {/* <PrimaryButton disabled={true} sx={{ width: "33%", height: "150px", my: 1 }}>
          View Weekly Progress Evaluation
        </PrimaryButton>
        <PrimaryButton disabled={true} sx={{ width: "33%", height: "150px", my: 1 }}>
          View Documentation Evaluation
        </PrimaryButton>
        <PrimaryButton disabled={true} sx={{ width: "33%", height: "150px", my: 1 }}>
          View Final Evaluation
        </PrimaryButton> */}
      </Card>
    </Box>
  );

  // <div style={{}}>
  //   {/* <BarGraph /> */}
  //   {/* <LineGraph /> */}
  //   {/* <PieGraph /> */}
  //   {/* <Gauge /> */}
  // </div>
};

export default StudentDashboard;
